import { render, staticRenderFns } from "./HighlightedPickersList.vue?vue&type=template&id=05a77894&"
import script from "./HighlightedPickersList.vue?vue&type=script&lang=js&"
export * from "./HighlightedPickersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports